'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _orderBy = require('lodash/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _client = require('../../utils/client');

var _filter = require('constructicon/filter');

var _filter2 = _interopRequireDefault(_filter);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _leaderboardItem = require('constructicon/leaderboard-item');

var _leaderboardItem2 = _interopRequireDefault(_leaderboardItem);

var _leaderboard = require('constructicon/leaderboard');

var _leaderboard2 = _interopRequireDefault(_leaderboard);

var _pagination = require('constructicon/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _paginationLink = require('constructicon/pagination-link');

var _paginationLink2 = _interopRequireDefault(_paginationLink);

var _richText = require('constructicon/rich-text');

var _richText2 = _interopRequireDefault(_richText);

var _leaderboard3 = require('../../api/leaderboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Leaderboard = function (_Component) {
  _inherits(Leaderboard, _Component);

  function Leaderboard() {
    _classCallCheck(this, Leaderboard);

    var _this = _possibleConstructorReturn(this, (Leaderboard.__proto__ || Object.getPrototypeOf(Leaderboard)).call(this));

    _this.fetchLeaderboard = _this.fetchLeaderboard.bind(_this);
    _this.setFilter = _this.setFilter.bind(_this);
    _this.renderLeader = _this.renderLeader.bind(_this);
    _this.state = {
      status: 'fetching',
      q: null
    };
    return _this;
  }

  _createClass(Leaderboard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var refreshInterval = this.props.refreshInterval;

      this.fetchLeaderboard();
      this.interval = refreshInterval && setInterval(function () {
        return _this2.fetchLeaderboard(_this2.state.q, true);
      }, refreshInterval);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props !== prevProps) {
        this.fetchLeaderboard(this.state.q);
      }
    }
  }, {
    key: 'setFilter',
    value: function setFilter(filterValue) {
      var q = filterValue || null;
      this.setState({ q: q });
      this.fetchLeaderboard(q);
    }
  }, {
    key: 'removeExcludedGroups',
    value: function removeExcludedGroups(groups, values) {
      if (!values) return groups;

      return groups.filter(function (item) {
        var excluded = Array.isArray(values) ? values : values.split(',');
        return excluded.indexOf(item.group.value.toString()) === -1;
      });
    }
  }, {
    key: 'handleData',
    value: function handleData(data, excludeOffline, deserializeMethod, limit) {
      var leaderboardData = data.map(deserializeMethod).map(function (item) {
        return excludeOffline ? _extends({}, item, { raised: item.raised - item.offline }) : item;
      });

      return (0, _orderBy2.default)(leaderboardData, ['raised'], ['desc']).map(function (item, index) {
        return _extends({}, item, { position: index + 1 });
      }).slice(0, limit);
    }
  }, {
    key: 'fetchLeaderboard',
    value: function fetchLeaderboard(q, refresh) {
      var _this3 = this;

      var _props = this.props,
          campaign = _props.campaign,
          charity = _props.charity,
          country = _props.country,
          deserializeMethod = _props.deserializeMethod,
          endDate = _props.endDate,
          event = _props.event,
          excludeOffline = _props.excludeOffline,
          excludePageIds = _props.excludePageIds,
          group = _props.group,
          groupID = _props.groupID,
          limit = _props.limit,
          maxAmount = _props.maxAmount,
          minAmount = _props.minAmount,
          page = _props.page,
          pageIds = _props.pageIds,
          startDate = _props.startDate,
          type = _props.type;


      !refresh && this.setState({
        status: 'fetching',
        data: undefined
      });

      (0, _leaderboard3.fetchLeaderboard)({
        campaign: campaign,
        charity: charity,
        country: country,
        endDate: endDate,
        event: event,
        excludePageIds: type === 'group' ? undefined : excludePageIds,
        group: group,
        groupID: groupID,
        limit: (0, _client.isJustGiving)() ? limit : limit + 5,
        maxAmount: maxAmount,
        minAmount: minAmount,
        page: page,
        pageIds: pageIds,
        q: q,
        startDate: startDate,
        type: type
      }).then(function (data) {
        return type === 'group' ? _this3.removeExcludedGroups(data, excludePageIds) : data;
      }).then(function (data) {
        _this3.setState({
          status: 'fetched',
          data: _this3.handleData(data, excludeOffline, deserializeMethod || _leaderboard3.deserializeLeaderboard, limit)
        });
      }).catch(function (error) {
        _this3.setState({
          status: 'failed'
        });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          status = _state.status,
          _state$data = _state.data,
          data = _state$data === undefined ? [] : _state$data;
      var _props2 = this.props,
          leaderboard = _props2.leaderboard,
          filter = _props2.filter,
          pageSize = _props2.pageSize,
          showPage = _props2.showPage;


      return _react2.default.createElement(
        'div',
        null,
        filter && _react2.default.createElement(_filter2.default, _extends({ onChange: this.setFilter }, filter)),
        _react2.default.createElement(
          _leaderboard2.default,
          _extends({
            loading: status === 'fetching',
            error: status === 'failed'
          }, leaderboard),
          data.length && _react2.default.createElement(
            _pagination2.default,
            { max: pageSize, toPaginate: data },
            function (_ref) {
              var currentPage = _ref.currentPage,
                  isPaginated = _ref.isPaginated,
                  prev = _ref.prev,
                  next = _ref.next,
                  canPrev = _ref.canPrev,
                  canNext = _ref.canNext,
                  pageOf = _ref.pageOf;
              return _react2.default.createElement(
                'div',
                null,
                currentPage.map(_this4.renderLeader),
                pageSize && isPaginated && _react2.default.createElement(
                  _grid2.default,
                  { align: 'center', justify: 'center' },
                  _react2.default.createElement(_paginationLink2.default, {
                    onClick: prev,
                    direction: 'prev',
                    disabled: !canPrev
                  }),
                  showPage && _react2.default.createElement(
                    _richText2.default,
                    { size: -1 },
                    pageOf
                  ),
                  _react2.default.createElement(_paginationLink2.default, {
                    onClick: next,
                    direction: 'next',
                    disabled: !canNext
                  })
                )
              );
            }
          )
        )
      );
    }
  }, {
    key: 'renderLeader',
    value: function renderLeader(leader, i) {
      var _props$leaderboardIte = this.props.leaderboardItem,
          leaderboardItem = _props$leaderboardIte === undefined ? {} : _props$leaderboardIte;


      return _react2.default.createElement(_leaderboardItem2.default, _extends({
        key: i,
        title: leader.name,
        subtitle: leader.subtitle,
        image: leader.image,
        amount: (0, _numbro2.default)(leader.raised).formatCurrency('0,0'),
        href: leader.url,
        rank: leader.position
      }, leaderboardItem));
    }
  }]);

  return Leaderboard;
}(_react.Component);

Leaderboard.propTypes = {
  /**
   * The campaign uid to fetch pages for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The charity uid to fetch pages for
   */
  charity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The event uid to fetch pages for (JG only)
   */
  event: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * Country code for API (JG only)
   */
  country: _propTypes2.default.oneOf(['au', 'ca', 'gb', 'hk', 'ie', 'nz', 'sg', 'uk', 'us', 'za']),

  /**
   * The type of page to include in the leaderboard
   */
  type: _propTypes2.default.oneOf(['group', 'individual', 'team']),

  /**
   * The group value(s) to filter by
   */
  group: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * Start date filter (ISO Format)
   */
  startDate: _propTypes2.default.string,

  /**
   * End date filter (ISO Format)
   */
  endDate: _propTypes2.default.string,

  /**
   * The number of records to fetch
   */
  limit: _propTypes2.default.number,

  /**
   * The number of records to show per page, disables pagination if not specified.
   */
  pageSize: _propTypes2.default.number,

  /**
   * The page to fetch
   */
  page: _propTypes2.default.number,

  /**
   * The group ID to group the leaderboard by (only relevant if type is group)
   */
  groupID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Override the deserializeLeaderboard method
   */
  deserializeMethod: _propTypes2.default.func,

  /**
   * Props to be passed to the Constructicon Leaderboard component
   */
  leaderboard: _propTypes2.default.object,

  /**
   * Props to be passed to the Constructicon LeaderboardItem component
   */
  leaderboardItem: _propTypes2.default.object,

  /**
   * Props to be passed to the Filter component (false to hide)
   */
  filter: _propTypes2.default.any,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number
};

Leaderboard.defaultProps = {
  limit: 10,
  showPage: false,
  page: 1,
  filter: {}
};

exports.default = Leaderboard;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/leaderboard/index.js
// module id = 1436
// module chunks = 0